<template>
  <div>
    <h3 class="mt-5"  v-if="!onPlacementsSingle">Editing your placement review.</h3>
    <p  v-if="!onPlacementsSingle">Your End of Placement Review has been submitted for approval. Once approved this plan will be complete and you can view your manager’s review and download a copy. You may edit your plan prior to your manager providing approval.</p>

    <div class="card">
      <ul class="list-data no-links no-hover">
        <li v-if="!onPlacementsSingle">
          <div class="row align-items-center">
            <div class="col">
              <p>Overall Comments</p>
            </div>

            <div class="col-auto">
              <router-link v-if="placementEndComponentGraduateCommentsSubmitted && placementEndComponentIsPendingReview" :to="{ name: 'placements.single.end.admin.objectives', params: { placementId: placement.id } }" class="btn btn-sm btn-outline-dark">
                  <font-awesome :icon="['fal', 'pencil']" class="mr-2"/>
                  Edit
              </router-link>
              <span v-else-if="placementIsFinalised" class="status status-success">Submitted</span>
              <span v-else class="status status-default">Pending</span>
            </div>
          </div>
        </li>

        <template v-if="placementEndComponentIsPendingReview">
          <li>
            <div class="row align-items-center">
              <div class="col">
                <p>Manager Capability Assessment</p>
              </div>

              <div class="col-auto">
                <span v-if="placementEndComponentCapabilityAssessmentComplete" class="status status-success">Complete</span>
                <span v-else class="status status-default">Pending</span>
              </div>
            </div>
          </li>

          <li>
            <div class="row align-items-center">
              <div class="col">
                <p>Manager Overall Placement Assessment</p>
              </div>

              <div class="col-auto">
                <span v-if="placementEndComponentOverallAssessmentComplete" class="status status-success">Complete</span>
                <span v-else class="status status-default">Pending</span>
              </div>
            </div>
          </li>
        </template>
      </ul><!-- /.list-data -->
    </div><!-- /.card -->

    <template v-if="placementEndComponentIsPendingReview">
      <h3 class="mt-5">Status</h3>

      <div v-if="placementIsFinalised" class="alert alert-success">
        <strong>Your placement has been finalised.</strong>
      </div><!-- /.alert -->

      <div v-else class="alert alert-info">
        <strong>Pending Review.</strong> Your end of placement review is pending completion by your manager.
      </div><!-- /.alert -->
    </template>
  </div>
</template>

<script>
import { placementComputed } from 'vx/helpers'
import { helpers } from 'mixins/placements'

export default {
  mixins: [helpers],

  props: {
    onPlacementsSingle: {
      required: false,
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...placementComputed
  }
}
</script>
